import './App.css'
import vector from './source/Vector.svg'
import files from './source/files.svg'
import warning from './source/warning.svg'
import pic1 from './source/pic1.png'
import pic2 from './source/pic2.png'
import pic3 from './source/pic3.png'
import pic4 from './source/pic4.png'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';

export default function App() {
  return (
    <Router>
       <Routes>
        <Route path='/' element={<MainLayot/>}/>
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/terms-of-service" element={<Terms/>}/>
      </Routes>
    </Router>
  );
}


function MainLayot() {
  return (
   <div className="container">
<div className="main-frame">
<div className="top-bar">
<div className="icons">
<Link to="/"><img className="icon" src={vector} alt="icon" /></Link>
<Link to="/privacy-policy"><img className="icon" src={warning} alt="icon" /></Link>
<Link to="/terms-of-service"><img className="icon" src={files} alt="icon" /></Link>
</div>
<div className="company-name">Mukammal LLC</div>
</div>
<div className="wrapper">
<div className="credentials-bar">
MC: 1759960 | DOT: 4445203 
</div>
<div className="main-section">
<div className="left-box">
<h1>
Mukammal LLC 
</h1>
<div className="btn-row">
<button className="yellow-btn">Get a Quote Today</button>
</div>
</div>
<div className="right-box">
<p>
Driving Excellence in Logistics – Premium transportation solutions
with nationwide coverage, uncompromising reliability, and exceptional
customer service.
</p>
<div className="arrow-box">→</div>
</div>
</div>
</div>
<div className="about-cred">
<div className="about-box">
<div className="badge">About Us</div>
<p className="yellow-card">
Founded with a commitment to excellence, Mukammal LLC
has established itself as a premier logistics and transportation
provider. Our team of experienced professionals delivers reliable,
efficient, and cost-effective solutions tailored to meet your
unique needs.
</p>
</div>
<div className="cred-box">
<div className="badge">Company Credentials</div>
<div className="cred-item">
<span>Motor Carrier (MC)</span>
<span>1759960</span>
</div>
<div className="cred-item">
<span>DOT Number</span>
<span>4445203</span>
</div>
</div>
</div>
<div className="next-btn">NEXT</div>
 <div className="solutions-wrapper">
      <div className="header">
        <h2>Comprehensive Logistics Solutions</h2>
        <p>
          From freight transportation to supply chain management, we offer a full suite of logistics services designed to streamline your operations and drive growth.
        </p>
      </div>

      <div className="solutions-grid">
        <div className="solution-card">
          
          <div className='head-solution-card '>
            <div className="solution-card-icon">🚚</div>
            Freight Transportation</div>
          <p>Full truckload and less-than-truckload shipping solutions with real-time tracking and guaranteed delivery windows.</p>
        </div>

        <div className="solution-card">

          <div className='head-solution-card '>
            <div className="solution-card-icon">📦</div>
            Dispatch Solutions</div>
          <p>24/7 dispatch services with advanced route optimization and comprehensive load management systems.</p>
        </div>

        <div className="solution-card">
          <div className='head-solution-card '>
            <div className="solution-card-icon">📊</div>
            Operations Management</div>
          <p>End-to-end supply chain optimization with inventory management and distribution network solutions.</p>
        </div>

        <div className="solution-card">
           <div className='head-solution-card '>
            <div className="solution-card-icon">🏢</div>
            Warehousing & Logistics</div>
          <p>Secure warehousing facilities with inventory management and distribution services nationwide.</p>
        </div>
      </div>
    </div>
    {/* ================= PREMIUM DIFFERENCE SECTION ================= */}
<div className="premium-section">
  <h2 className="premium-title">The Premium Difference</h2>
  <p className="premium-sub">
    Experience the advantages of partnering with a logistics provider that prioritizes
    excellence, reliability, and customer satisfaction above all else.
  </p>

  <div className="premium-grid">
    <div className="premium-card">
      <img src={pic1} alt="" />
      <h3>Operations Management</h3>
      <p>Fully compliant with DOT regulations and comprehensive insurance coverage.</p>
    </div>

    <div className="premium-card">
            <img src={pic2} alt="" />
      <h3>On-Time Delivery</h3>
      <p>98.9% on-time delivery rate with guaranteed delivery windows.</p>
    </div>

    <div className="premium-card">
                 <img src={pic3} alt="" />

      <h3>Nationwide Coverage</h3>
      <p>Coast-to-coast service network covering all 48 contiguous states.</p>
    </div>

    <div className="premium-card">
                 <img src={pic4} alt="" />
      <h3>24/7 Customer Support</h3>
      <p>Round-the-clock customer service and real-time shipment tracking.</p>
    </div>
  </div>
</div>
{/* ================= CLIENTS SECTION ================= */}
<div className="clients-section">
  <h2 className="clients-title">What Our Clients Say</h2>
  <p className="clients-sub">
    Don’t just take our word for it. Here’s what industry leaders have to say about their
    experience with Mukammal LLC INC.
  </p>

  <div className="client-grid">
    <div className="client-card">
      <div className="client-icon">ER</div>
      <h4>Emily Rodriguez</h4>
      <span>Global Distributor</span>
      <p>
        “The real-time tracking and communication throughout the shipping process gives us
        complete peace of mind. Highly recommended!”
      </p>
    </div>

    <div className="client-card">
      <div className="client-icon">MC</div>
      <h4>Michael Chen</h4>
      <span>Retail Solutions Inc</span>
      <p>
        “Outstanding service quality and competitive pricing. They’ve helped us optimize
        our supply chain and reduce costs significantly.”
      </p>
    </div>

    <div className="client-card">
      <div className="client-icon">SJ</div>
      <h4>Sarah Johnson</h4>
      <span>Manufacturing Corp</span>
      <p>
        " Mukammal LLC  has been our trusted logistics partner for over 3 years.
        Their reliability and professionalism are unmatched in the industry.”
      </p>
    </div>
  </div>
</div>

{/* ============== CALL TO ACTION SECTION ============== */}
<div className="cta-section">
  <h2 className="cta-title">Ready to Transform Your Logistics</h2>
  <p className="cta-sub">
    Join thousands of satisfied clients who trust Mukammal LLC for their transportation needs.
  </p>

  <div className="cta-buttons">
    <a href='/' className="cta-btn">Call Now:+1 (209)589-9871</a>
    <a href='/' className="cta-btn">Send Email</a>
  </div>
</div>

{/* ============== FOOTER SECTION ============== */}
<footer className="footer">
  <div className="footer-grid">

    <div className="footer-col">
      <h4>Mukammal LLC </h4>
      <p>Mukammal Logistics & Transportation</p>
      <p>MC: 1759960 | DOT: 4445203 </p>
      <p>Cincinati OH </p>
      <p>Phone: +1 (209)589-9871 | Email: contact@mukammallc.com</p>
    </div>

    <div className="footer-col">
      <h4>Quick Links</h4>
      <ul>
        <li><Link to="/" onClick={() => {  window.scrollTo({
      top: 0,
      behavior: "smooth"
    })}}>Home</Link></li>
        <li><Link to="/privacy-policy" onClick={() => {  window.scrollTo({
      top: 0,
      behavior: "smooth"
    })}}>Privacy and Policy</Link></li>
        <li><Link to="/terms-of-service" onClick={() => {  window.scrollTo({
      top: 0,
      behavior: "smooth"
    })}}> Terms of Services</Link></li>
      </ul>
    </div>

    <div className="footer-col">
      <h4>Services</h4>
      <ul>
        <li>Freight Transportation</li>
        <li>Dispatch Solutions</li>
        <li>Supply Chain Management</li>
        <li>Warehousing & Logistics</li>
      </ul>
    </div>

  </div>

  <div className="footer-bottom">
    © 2024 Mukammal LLC INC. All rights reserved. <br />
    Created by Denny Clark
  </div>
</footer>


</div>
</div>
  );
}



function PrivacyPolicy(){
  return (
    <div className='container'>
      <div className='main-frame'>
<div className="top-bar">
<div className="icons">
<Link to="/"><img className="icon" src={vector} alt="icon" /></Link>
<Link to="/privacy-policy"><img className="icon" src={warning} alt="icon" /></Link>
<Link to="/terms-of-service"><img className="icon" src={files} alt="icon" /></Link>
</div>
<div className="company-name">Mukammal LLC</div>
</div>
<div className="privacy-wrapper">
  <div className="page-title-wrapper">
    <h1 className="page-title">Privacy Policy</h1>
  </div>

  <div className="policy-card">
    <p>
      Mukammal LLC is committed to protecting your privacy and personal
      information. This policy explains how we collect, use, and safeguard your data.
    </p>
  </div>

  <div className="updated-box">
    Last Updated: December 26, 2024 | Effective Date: December 26, 2024
  </div>

  <div className="policy-section">
    <div className="section-badge">Company Information</div>

    <div className="company-two-col">
      <div className="left-info">
        <p>Company Name: Mukammal</p>
        <p>Address: Cincinatti OH</p>
               <p>Phone:+1 (209)589-9871</p>
        <p>Email: contact@Mukammallc.com</p>
      </div>

      <div className="right-info">
        <p>Motor Carrier (MC): 1759960</p>
        <p>DOT Number: 4445203</p>
      </div>
    </div>
  </div>

   <div className="policy-section">
    <div className="section-badge">Introduction</div>

    <ul className="policy-list">
      <ul>Prime Us Incorporated ("we," "us," "our") is committed to protecting your privacy. This Privacy Policy describes: </ul>
      <li>What personal information is collected,</li>
<li>How it is used</li>
<li>Whether and how consumers’ opt-in information is shared.</li>
      <ul>By using our website or services, you consent to the practices described below</ul>
    </ul>
  </div>

  <div className="policy-section">
    <div className="section-badge">What Personal Information We Collect</div>

    <ul className="policy-list">
      <li>Contact information: name, email address, phone number, billing/shipping address</li>
      <li>Device & usage data: IP address, browser type/version, device type, pages visited, date/time stamps.</li>
      <li>Service data: details you provide when requesting quotes, scheduling cleanings, or paying for services</li>
      <li>Mobile data: your device ID, mobile carrier, and location when you access our services via mobile.</li>
    </ul>
  </div>

  <div className="policy-section">
    <div className="section-badge">How We Use Your Personal Information</div>

    <ul className="policy-list">
      <li>Provide and fulfill services – process bookings, payments, estimates, scheduling</li>
      <li>Enhance user experience – personalize content and optimize our website.</li>
      <li>Communications – respond to inquiries, send updates, confirmations, reminders.</li>
      <li>Marketing – email/SMS promotions and offers (only with your consent).</li>
      <li>Operational & legal – fulfill contracts, comply with legal obligations, detect/prevent fraud.</li>
    </ul>
  </div>

 <div className="policy-section">
    <div className="section-badge">Opt-In Information & How It’s Shared</div>
    <ul className="policy-list">
      <li>We will only share this data with third-party service providers (e.g., email or SMS platforms) for the sole purpose of sending messages on our behalf</li>
      <li>No mobile opt-in or text message consent will be shared with third parties or affiliates.</li>
    </ul>
  </div>

   <div className="policy-section">
    <div className="section-badge">Cookies & Tracking Technologies</div>
    <ul className="policy-list">
      <li>Support essential site functionality</li>
      <li>Remember preferences;</li>
      <li>Analyze site performance and usage</li>
      <li>You can control cookies via your browser settings.</li>
    </ul>
  </div>



  <div className="policy-section">
    <div className="section-badge">How We Store & Protect Your Data</div>
    <br/>
<h3>
   Your information is stored securely on encrypted servers and accessed only by authorized personnel and service providers who follow this Privacy Policy. While we use industry-standard safeguards, no system is completely secure.
</h3>
  </div>

  <div className="policy-section">
    <div className="section-badge">Data Sharing & Disclosure</div>
    <ul className="policy-list">
      <li>Service providers: for analytics, communications, and payment processing</li>
      <li>Affiliates/business partners: only when necessary to fulfill services (e.g., subcontractors), always under confidentiality terms.</li>
      <li>Legal authorities: to comply with legal requirements or to protect rights and safety</li>
    </ul>
    <h3>We do not sell or lease your personal info to third parties</h3>
  </div>

  <div className="policy-section">
    <div className="section-badge">Retention of Your Data</div>
    <h3>We retain your personal information only as long as needed for business purposes, legal obligations, dispute resolution, fraud prevention, or as required by law.</h3>
  </div>

<div className="policy-section">
    <div className="section-badge">International Transfers</div>
    <h3>Your data may be transferred and processed in countries outside the U.S. We ensure standard contractual protections or lawful transfer mechanisms are in place</h3>
  </div>


   <div className="policy-section">
    <div className="section-badge">Your Rights & Choices</div>
    <ul className="policy-list">
      <li>Opt in or out of marketing communications anytime via links or reply commands (“STOP”).</li>
      <li>Access, update, correct, or delete your personal information—contact us at the email below.</li>
      <li>Control cookies through browser settings</li>
    </ul>
  </div>

  <div className="policy-section">
    <div className="section-badge">Changes to this Policy</div>
    <h3>Any changes will be posted here, and if materially significant, we'll notify you via email or website notification, updating the “Last Updated” date.</h3>
  </div>
</div>

 <div className="policy-section">
    <div className="section-badge">Mukammal LLC Terms of Service</div>
    <h3>By texting Mukammal LLC at +1 (209)589-9871, you agree to receive Customer care, Marketing, and Account Notification messages. Reply STOP to opt-out; Reply HELP for support; Message & data rates may apply; Messaging frequency may vary. Visit our Privacy Policy and Terms of Service.

To unsubscribe from text marketing, reply STOP to any message or use the unsubscribe link. Other requests won't be honored as valid opt-out methods.

We don’t charge for this service, but your carrier may. Message/data rates may apply.

Text HELP for questions or contact us at www.mukammallc.com

We reserve the right to change our SMS number/short code. You are responsible for checking updates. Messages sent to outdated numbers may not be received.

To the extent permitted by law, we’re not liable for failed, delayed, or misdirected delivery or any resulting actions you may take</h3>
  </div>

      </div>

    </div>
  );
}


function Terms(){
  return (
    <div className='container'>
      <div className='main-frame'>
<div className="top-bar">
<div className="icons">
<Link to="/"><img className="icon" src={vector} alt="icon" /></Link>
<Link to="/privacy-policy"><img className="icon" src={warning} alt="icon" /></Link>
<Link to="/terms-of-service"><img className="icon" src={files} alt="icon" /></Link>
</div>
<div className="company-name">Mukammal LLC</div>
</div>
<div className="privacy-wrapper">
  <div className="page-title-wrapper">
    <h1 className="page-title">Terms of Services</h1>
  </div>

  <div className="policy-card">
    <p>
      These terms govern your use of Mukammal LLC's logistics and transportation services. Please read them carefully before using our services.
    </p>
  </div>

  <div className="updated-box">
    Last Updated: December 26, 2024 | Effective Date: December 26, 2024
  </div>

  <div className="policy-section">
    <div className="section-badge">Company Information</div>

    <div className="company-two-col">
      <div className="left-info">
        <p>Company Name: Mukammal</p>
        <p>Address: Cincinatti OH</p>
        <p>Phone:+1 (209)589-9871</p>
        <p>Email: contact@Mukammallc.com</p>
      </div>

      <div className="right-info">
        <p>Motor Carrier (MC): 1759960</p>
        <p>DOT Number: 4445203</p>
      </div>
    </div>
  </div>

  <div className="policy-section">
    <div className="section-icon">W</div>
    <div className="section-badge">Website Usage</div>

    <ul className="policy-list">
      <li>This site is intended for logistics-related inquiries and service engagement. Unauthorized use is prohibited</li>
    </ul>
  </div>


  <div className="policy-section">
    <div className="section-icon">S</div>
    <div className="section-badge">Services</div>

    <ul className="policy-list">
      <li>We provide freight transportation services governed by separate contracts or broker agreements.</li>
    </ul>
  </div>

  <div className="policy-section">
    <div className="section-icon">L</div>
    <div className="section-badge">Liability</div>

    <ul className="policy-list">
      <li>We are not liable for losses or damages resulting from website use or third-party links.</li>
    </ul>
  </div>

  
  <div className="policy-section">
    <div className="section-icon">S</div>
    <div className="section-badge">SMS Terms of Service</div>

    <ul className="policy-list">
      <li>By opting into SMS from a web form or other medium, you are agreeing to receive SMS messages from [Brand/DBA]. This includes SMS messages for [Campaign Types]. Message frequency varies. Message and data rates may apply. See privacy policy at https://www.mukammalllc.com/privacy-policy. Message HELP for help. Reply STOP to any message to opt out.</li>
    </ul>
  </div>

</div>



      </div>

    </div>
  );
}